import * as Yup from 'yup';

import {
  getRecipientsRule,
  getExperienceSettingsRule,
  getNameRule,
  getPaymentMethodRule,
  getProductsRule,
  getTypeRule,
  getSettingsAutomationRule
} from './common';

//! Step 5
const getReviewAndActivateRule = ({
  isPaymentMethodRequired = false,
  isInputMessageRequired = true
}) => {
  return Yup.object().shape({
    products: getProductsRule(),
    paymentMethod: getPaymentMethodRule(isPaymentMethodRequired),
    name: getNameRule('automationName'),
    type: getTypeRule('automationName'),
    experienceSettings: getExperienceSettingsRule({ isInputMessageRequired }),
    settings: getSettingsAutomationRule(),
    contacts: getRecipientsRule()
  });
};

export { getReviewAndActivateRule };
